export enum ForSaleStrings {
  NotFindingHeadling = 'Hittar du inte vad du söker?',
  NotFindingText = 'Oroa dig inte. Vi får in nya bostäder hela tiden. Kanske är din drömbostad bara ett par dagar bort? Skapa en bevakning så att du inte missar när den dyker upp!',
  FetchError = 'Kunde inte hämta bostäder just nu. Försök igen om en liten stund.',
  Estates = 'Bostäder',
  SingleEstate = 'Bostad',
  NoResults = 'Din sökning gav inga träffar',
  Loading = 'Laddar...',
  Bidding = 'Budgivning pågår',
  BiddingShort = 'Budgivning',
}
